import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import Avatar from '../avatar/Avatar';

const PageTitle: React.FC<{ title: string; showOrganization?: boolean }> = ({ title, showOrganization = true }) => {
  const avatar = useSelector((state: RootState) => state.organization.organization?.avatar);
  const name = useSelector((state: RootState) => state.organization.organization?.name);

  return (
    <>
      <div className="title-wrapper">
        <span className="title">{title}</span>
        {showOrganization && <Avatar src={avatar} width={36} height={36}></Avatar>}
        {showOrganization && name && <span className="name">{name}</span>}
      </div>
    </>
  );
};

export default PageTitle;
